import {DialogTitle} from '@apps-common/ui-components';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  InputAdornment,
  TextField,
} from '@mui/material';
import FileSaver from 'file-saver';
import PropTypes from 'prop-types';
import React, {useState} from 'react';

const FILE_EXTENSION = '.geojson';

export const DownloadAoiDialog = props => {
  const [filename, setFilename] = useState('explorer-aoi');

  return (
    <Dialog
      open
      fullWidth
      onClose={props.onClose}
      data-testid="download-aoi-dialog"
    >
      <DialogTitle
        title={props.title || 'Download AOI'}
        subheader={
          props.subtitle || 'Areas of interest will be downloaded as a GeoJSON'
        }
        onClose={props.onClose}
      />
      <DialogContent>
        <TextField
          fullWidth
          variant="outlined"
          margin="dense"
          label="Filename"
          value={filename}
          onChange={evt => setFilename(evt.target.value)}
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">{FILE_EXTENSION}</InputAdornment>
              ),
            },
          }}
        />
      </DialogContent>
      <DialogActions>
        <Button
          color="primary"
          variant="contained"
          disabled={!filename}
          data-testid="download-aoi-button"
          onClick={() => {
            const collection = JSON.stringify({
              type: 'FeatureCollection',
              features: [props.aoi],
            });
            const blob = new Blob([collection], {
              type: 'text/plain;charset=utf-8',
            });
            FileSaver.saveAs(blob, `${filename}${FILE_EXTENSION}`);
            props.onClose();
          }}
        >
          Download
        </Button>
      </DialogActions>
    </Dialog>
  );
};

DownloadAoiDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  aoi: PropTypes.object,
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default DownloadAoiDialog;
